import { render, staticRenderFns } from "./MedicationDSS.vue?vue&type=template&id=f6f93fe6&"
import script from "./MedicationDSS.vue?vue&type=script&lang=js&"
export * from "./MedicationDSS.vue?vue&type=script&lang=js&"
import style0 from "./MedicationDSS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VRadio,VRadioGroup,VSimpleTable,VTextField})
